import styled from 'styled-components';
import { Text14Light } from '../../components/utils/Text/Text.styles';

export const PageContainer = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  padding-top: 1.6rem;
  padding-inline: 1.6rem;
  padding-bottom: 20rem;

  @media only screen and (min-width: 768px) {
    padding-top: 1.6rem;
    padding-bottom: 1.6rem;
  }
`;

export const Content = styled.div`
  margin-left: 4.4rem;
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
`;

export const AnswerText = styled(Text14Light)`
  color: #b089f6;
`;

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;
